/**
 * form-validation
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
	el: 'form.js-form-validation',

	events: {
		submit: 'onSubmit',
		'keyup input[type="email"]': 'onInputChange',
		'change input[type="checkbox"]': 'onInputChange',
	},

	onRender() {
		this.el.classList.add('js-form-invalid');
		this.el.querySelector('.js-form-submit').disabled = true;

		// @TODO: Remove when HubSpot forms has been implemented
	},

	onSubmit(e) {
		e.preventDefault();
	},

	onInputChange(e) {
		const input = e.target;
		const form = this.el;
		const btnSubmit = this.el.querySelector('.js-form-submit');

		if (input.required) {
			if (form.checkValidity()) {
				btnSubmit.disabled = false;
				form.classList.add('js-form-valid');
				form.classList.remove('js-form-invalid');
			} else {
				btnSubmit.disabled = true;
				form.classList.add('js-form-invalid');
				form.classList.remove('js-form-valid');
			}
		}
	},
});

export default View;
